import { useTranslation } from 'react-i18next'

export function TypingIndicator() {
  const { t } = useTranslation('chat')

  return (
    <div className="flex items-start gap-3 max-w-[70%]">
      <div className="rounded-2xl rounded-bl-md bg-white/10 px-4 py-3">
        <div className="flex items-center gap-1.5">
          <div className="h-2 w-2 rounded-full bg-gray-400 animate-bounce [animation-delay:0ms]" />
          <div className="h-2 w-2 rounded-full bg-gray-400 animate-bounce [animation-delay:150ms]" />
          <div className="h-2 w-2 rounded-full bg-gray-400 animate-bounce [animation-delay:300ms]" />
          <span className="ml-2 text-xs text-gray-500">{t('messages.typing')}</span>
        </div>
      </div>
    </div>
  )
}
